import { DashboardLayout } from "@/components/layout/DashboardLayout";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de confidentialité</h1>
        <div className="prose prose-blue max-w-none">
          <p>Dernière mise à jour : {new Date().toLocaleDateString()}</p>
          
          <h2>1. Introduction</h2>
          <p>
            Cette politique de confidentialité explique comment Sibystock collecte, utilise et protège vos données personnelles.
          </p>

          <h2>2. Collecte des données</h2>
          <p>
            Nous collectons les informations suivantes :
          </p>
          <ul>
            <li>Informations d'identification (nom, email)</li>
            <li>Données de l'entreprise</li>
            <li>Données d'utilisation</li>
          </ul>

          <h2>3. Utilisation des données</h2>
          <p>
            Vos données sont utilisées pour :
          </p>
          <ul>
            <li>Fournir nos services</li>
            <li>Améliorer notre plateforme</li>
            <li>Communiquer avec vous</li>
          </ul>

          <h2>4. Protection des données</h2>
          <p>
            Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données.
          </p>

          <h2>5. Vos droits</h2>
          <p>
            Vous avez le droit d'accéder, de modifier ou de supprimer vos données personnelles.
          </p>

          <h2>6. Contact</h2>
          <p>
            Pour toute question concernant cette politique, contactez-nous à contact@sibyagence.com
          </p>
        </div>
      </main>
    </div>
  );
}